import { useEffect, useState } from 'react';
import { getTapRates, putTapRates } from '../api';

export default function TapRates() {
  const [line, setLine] = useState<number>(0);
  const [applovin, setApplovin] = useState<number>(0);
  const [admob, setAdmob] = useState<number>(0);
  const [err, setErr] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  async function load() {
    try {
      setErr(null);
      const r = await getTapRates();
      setLine(r.line ?? 0);
      setApplovin(r.applovin ?? 0);
      setAdmob(r.admob ?? 0);
    } catch (e) {
      setErr(String(e));
    }
  }
  useEffect(() => void load(), []);

  async function save() {
    setSaving(true);
    setErr(null);
    try {
      await putTapRates({ line, applovin, admob });
      alert('保存しました');
    } catch (e) {
      setErr(String(e));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <h2>タップ率</h2>

      <div className="card">
        <h3>ネットワーク別タップ率</h3>
        <p className="muted">単位は 0〜1（例: 0.05 = 5%）</p>
        {err && <div className="error">{err}</div>}
        <div className="row" style={{ marginTop: 12, gap: 20 }}>
          <div className="col">
            <label>LINE FiveAd</label>
            <input
              type="number"
              step="0.01"
              min={0}
              max={1}
              value={line}
              onChange={(e) => setLine(Number(e.target.value))}
              style={{ width: 120 }}
            />
          </div>
          <div className="col">
            <label>AppLovin MAX</label>
            <input
              type="number"
              step="0.01"
              min={0}
              max={1}
              value={applovin}
              onChange={(e) => setApplovin(Number(e.target.value))}
              style={{ width: 120 }}
            />
          </div>
          <div className="col">
            <label>AdMob</label>
            <input
              type="number"
              step="0.01"
              min={0}
              max={1}
              value={admob}
              onChange={(e) => setAdmob(Number(e.target.value))}
              style={{ width: 120 }}
            />
          </div>
        </div>
        <div style={{ marginTop: 20 }}>
          <button disabled={saving} onClick={save}>
            保存
          </button>
        </div>
      </div>
    </div>
  );
}
